import axios from "axios";
import { addMessage } from "conten/mensajes/MessagesActions";
import {
  GUARDAR_PLAN,
  GUARDAR_PLAN_ZONA,
  guardarPlanError,
  guardarPlanSuccess,
  guardarPlanZonaError,
  guardarPlanZonaSuccess,
  listarPlanError,
  listarPlanSuccess,
  listarPlanZonaError,
  listarPlanZonaSuccess,
  PLAN_LISTAR,
  PLAN_ZONA_LISTAR,
  LISTAR_ZONA_ACTIVA,
  listarZonaActivaSuccess,
  listarZonaActivaError
} from './PlanesActions';
import PlanApi from './PlanesApiClient';
import { ofType } from 'redux-observable';
import { Observable } from "rxjs";
import { mergeMap } from 'rxjs/operators';
import { OK, ERROR, apiTimeout } from "config/general/Configuracion";
import { of } from 'rxjs';


export const listarPlanEpic = (action$) =>
  action$.pipe(
    ofType(PLAN_LISTAR),
    mergeMap((action) =>
      PlanApi.listarPlan(action.paginacion)
        .then((response) => listarPlanSuccess(response.data))
        .catch((error) => listarPlanError(error))
    )
  );

export const listarPlanZonaEpic = (action$) =>
  action$.pipe(
    ofType(PLAN_ZONA_LISTAR),
    mergeMap((action) =>
      PlanApi.listarPlanZona(action.paginacion)
        .then((response) => listarPlanZonaSuccess(response.data))
        .catch((error) => listarPlanZonaError(error))
    )
  );
export const listarZonaActivaEpic = (action$) =>
  action$.pipe(
    ofType(LISTAR_ZONA_ACTIVA),
    mergeMap(() =>
      PlanApi.listarZonaActiva()
        .then((response) => listarZonaActivaSuccess(response.data))
        .catch((error) => listarZonaActivaError(error))
    )
  );
export const guardarPlanZonaEpic = (action$, state$) =>
  action$.pipe(
    ofType(GUARDAR_PLAN_ZONA),
    mergeMap(
      (action) =>
        new Observable((obs) => {
          axios.defaults.timeout = apiTimeout;
          axios(PlanApi.guardarPlanZona(action.planZona))
            .then((response) => {
              if (response.status === 200 || response.status === 201) {
                obs.next(guardarPlanZonaSuccess(response.data));
                obs.complete();
                action.onSuccess(OK, response.data);
              }
            })
            .catch((error) => {
              obs.next(guardarPlanZonaError(error));
              var mensajeError = "Hubo un problema: " + error.message;
              if (error && error.response && error.response.data) {
                mensajeError = error.response.data;
              }
              action.onSuccess(ERROR, mensajeError + "");
              obs.next(
                addMessage({ variant: "error", message: mensajeError + "" })
              );
              obs.complete();
            });
        })
    )
  );

export const guardarPlanEpic = (action$, state$) =>
  action$.pipe(
    ofType(GUARDAR_PLAN),
    mergeMap(
      (action) =>
        new Observable((obs) => {
          axios.defaults.timeout = apiTimeout;
          axios(PlanApi.guardarPlan(action.plan))
            .then((response) => {
              if (response.status === 200 || response.status === 201) {
                obs.next(guardarPlanSuccess(response.data));
                obs.complete();
                action.onSuccess(OK, response.data);
              }
            })
            .catch((error) => {
              obs.next(guardarPlanError(error));
              var mensajeError = "Hubo un problema: " + error.message;
              if (error && error.response && error.response.data) {
                mensajeError = error.response.data;
              }
              action.onSuccess(ERROR, mensajeError + "");
              obs.next(
                addMessage({ variant: "error", message: mensajeError + "" })
              );
              obs.complete();
            });
        })
    )
  );

export const actualizarPlacaEpic = (action$) =>
  action$.pipe(
    ofType(ACTUALIZAR_PLACA),
    mergeMap((action) =>
      PlanApi.actualizarPlaca(action.placa)
        .then((response) => actualizarPlacaSuccess(response.data))
        .catch((error) => actualizarPlacaError(error))
    )
  );




